<template>
  <div>
    <div class='copy' v-html='config.copy'></div>
    <a :class='buttonClasses' :id='config.id' :href='config.link' @click='onClick($event)'>
      {{ config.buttonText }}
    </a>
  </div>
</template>
<script>

export default {
  props: {
    config: {type: Object,
      default: () => {
        return {
          copy: '',
          buttonText: 'OK',
          classes: []
        }
      }
    }
  },
  methods: {
    onClick (event) {
      if (typeof this.config.link !== 'undefined') {
        const newTab = window.open(this.config.link, '_blank')
        if (!newTab || newTab.closed) {
          document.location.href = this.config.link
        }
      } else if (typeof this.config.scrollTo !== 'undefined') {
        event.preventDefault()
        this.$emit('scroll', this.config.scrollTo)
      } else {
        event.preventDefault()
        this.$emit('click', this)
      }
    },
    buttonTarget () {
      if (typeof this.config.target !== 'undefined') {
        return this.config.target
      } else {
        return '_self'
      }
    }
  },
  computed: {
    buttonClasses () {
      return 'button ' + this.config.classes.join(' ')
    }
  }
}
</script>
<style lang='scss' scoped>
  .result-button {
    padding: 1rem 0;
    text-align:center;
    .copy {
      margin-bottom: 1rem;
    }
    a.button {
      border:1px solid #ccc;
      background-color: #ededed;
      border-radius: 3px;
      text-decoration: none;
    }
  }

  a.button {
    transition: 0.3s all;
  }

</style>
